<template>
    <div id="main-content"
         class="main mx-auto max-w-[1358px] flex gap-9 relative my-4">
        <HeadComponent :element/>
        <JsonLdSchema :element="element" :text="text" />
        <div class="max-w-[1056px] flex-1">
            <div class="mx-auto my-0 sm:p-7 sm:shadow-element rounded-[10px] relative">
                <a v-if="checkAccess([1,6,7])"
                   :href="route('text_editor', {
                       textable_type: 'App/Models/Content',
                       textable_id: element.id,
                       id: text.id
                   })"
                   class="cursor-pointer hover:bg-blue-400 text-gray-600 hover:text-white rounded absolute top-0 right-0 mt-3 mr-3"
                   v-html="collection.edit.path"/>
                <div class="max-w-[692px] mx-auto">
                    <div class="flex sm:justify-between items-start flex-wrap flex-row mb-2 md:mb-8 gap-4">
                        <section>
                            <ArticleAuthor :element="Object.assign(element, {text: text})"
                                           class="mr-auto"/>
                            <span
                                class="text-[10px] mt-1 uppercase cursor-pointer text-blue-500 hover:opacity-100 opacity-80 duration-75"
                                @click="goPreviousPage">Назад</span>
                        </section>

                        <CopyUrlToBufferVue :url="redirect_url">
                            <span
                                class="px-3 py-2 relative flex items-center rounded-[10px] ease-out duration-300 border border-transparent border-solid hover:border-main-shade transition-colors text-base font-medium text-main-accent">
                                <span class="mr-2"
                                      v-html="collection.link_arrow.path"></span> Поделиться
                            </span>
                        </CopyUrlToBufferVue>
                    </div>
                    <div class="flex flex-wrap">
                        <TagHashed v-for="tag in element.tags"
                                   :key="tag"
                                   :all_tags="all_tags"
                                   :filter="filters.tag"
                                   :tag="tag"/>
                    </div>
                    <section id="article-container"
                             class="article-container w-full px-2 sm:px-0"
                             v-html="schema">
                    </section>

                    <CopyUrlToBufferVue :url="redirect_url"
                                        class="mt-4">
                        <span
                            class="px-3 py-2 relative flex items-center rounded-[10px] ease-out duration-300 border border-transparent border-solid hover:border-main-shade transition-colors text-base font-medium text-main-accent">
                            <span class="mr-2"
                                  v-html="collection.link_arrow.path"></span> Поделиться
                        </span>
                    </CopyUrlToBufferVue>
                </div>
            </div>

            <BannerManager :odd="Math.round(Math.random())" class="mt-10"/>
        </div>

        <!--		 right column -->
        <SidebarNewAndPopular :content
                              :element
                              :popular
                              :tag_height/>
    </div>
</template>
<script setup>
import HeadComponent from '@/shared/HeadComponent.vue';
import JsonLdSchema from '@/shared/JsonLdSchema.vue';
import {router} from '@inertiajs/vue3';
import {htmlOutput} from '@/shared/htmlOutput.js';
import {computed, onMounted, ref} from 'vue';
import CopyUrlToBufferVue from '@/shared/CopyUrlToBuffer.vue';
import {icons as collection} from '@/shared/assets.js';
import {checkAccess, goPreviousPage} from '@/shared/helpers.js';
import TagHashed from '@/Pages/Content/Components/TagHashed.vue';
import ArticleAuthor from '@/Pages/Articles/Components/ArticleAuthor.vue';
import LandLayout from '@/Layouts/LandLayout.vue';
import BannerManager from '@/shared/Banners/BannerManager.vue';
import SidebarNewAndPopular from '@/Pages/Content/Components/SidebarNewAndPopular.vue';

defineOptions({layout: LandLayout});
const props = defineProps(['element', 'content', 'all_tags', 'filters', 'text', 'schema', 'popular']);
let text_output = ref('');

// define the Model=>ID key value pare for the Trait purpose
let getModel = computed(() => {
    return Object.assign({}, {
        type: 'Content',
        id: props.element.id
    });
});
let redirect_url = ref('');
let tag_height = ref('height:900px;');

onMounted(() => {
    text_output.value = htmlOutput(props?.text?.schema) ?? '';
    redirect_url.value = window.location.href;
    tag_height.value = 'height:' + (window.innerHeight - 250) + 'px;';
});
</script>

<style>
.article_side {
    @apply flex flex-col ringed rounded-[10px] shadow-element px-3 py-4 mb-5
}

@media (max-width: 760px) {
    .article-container h1,
    .article-container h2,
    .article-container h3,
    .article-container h4,
    .article-container h5,
    .article-container h6 {
        @apply text-2xl;
    }
}

@media (max-width: 560px) {
    .article-container h1,
    .article-container h2,
    .article-container h3,
    .article-container h4,
    .article-container h5,
    .article-container h6 {
        @apply text-xl;
    }

    .article-container div {
        @apply px-0;
    }

    .article-container p {
        @apply px-0;
        /* @apply text-sm; */
    }
}

/* .tag {
    @apply flex items-center w-auto min-h-0 justify-center ease-out duration-300 transition-colors px-4 py-2.5 border bg-white border-[#D1D9E2] border-solid rounded-[15px] shadow-tag text-main-secondary text-xs font-bold cursor-pointer hover:text-white hover:border-transparent hover:bg-main-accent;
} */
</style>
